'use client';

import NextLink from '@/components/next-link';
import Container from '@/components/ui/container';
import { usePathname } from '@/i18n/navigation';
import { sortJSONKeys } from '@/utils/global';
import { event_top_nav_clicked, event_button_click } from '@/utils/gtm';
import { useLocale } from 'next-intl';
import Categories from '../categories';

const SLICE_LIMIT = 2;

function Navbar({ links, isMobile }) {
  const locale = useLocale();

  const pathname = usePathname();

  const isActive = (link) => {
    return pathname === link?.url;
  };

  const navLinks = sortJSONKeys(links?.value || [], isMobile);
  const getLocalizedTitle = (item) => {
    return item?.[locale === 'en' ? 'title-en' : 'title-ar'];
  };

  return (
    <div className='border-b-tertiary-300 text-dark border-b py-1 max-sm:hidden'>
      <Container className='relative flex items-center justify-between'>
        <div className='flex flex-1 items-center gap-[27px] overflow-x-auto overflow-y-hidden'>
          <Categories />

          {navLinks?.slice(0, SLICE_LIMIT)?.map((link, index) =>
            link[`${isMobile ? 'mobile-' : ''}active`] ? (
              <NextLink
                key={index}
                href={link?.url?.startsWith('/') ? link?.url : `/${link?.url}`}
                onClick={() => {
                  event_top_nav_clicked({ menu_name: getLocalizedTitle(link) });
                  event_button_click({
                    button_name: link?.['title-en'],
                    button_destination: link?.url?.startsWith('/')
                      ? link?.url
                      : '/' + link?.url,
                    button_location: 'header',
                  });
                }}
                className={`${isActive(link) ? 'text-primary border-primary border-b font-bold' : ''} max-sm:text-primary text-[14.4px] whitespace-nowrap capitalize max-md:text-sm max-sm:text-xs`}
              >
                {getLocalizedTitle(link)}
              </NextLink>
            ) : null
          )}
          <div className='ms-auto flex flex-1 items-center justify-end gap-8'>
            {navLinks?.slice(SLICE_LIMIT)?.map((link, index) => (
              <NextLink
                key={index}
                href={link?.url?.startsWith('/') ? link?.url : `/${link?.url}`}
                onClick={() => {
                  event_top_nav_clicked({ menu_name: getLocalizedTitle(link) });
                  event_button_click({
                    button_name: link?.['title-en'],
                    button_destination: link?.url?.startsWith('/')
                      ? link?.url
                      : '/' + link?.url,
                    button_location: 'header',
                  });
                }}
                className={`${isActive(link) ? 'text-primary border-primary border-b font-bold' : ''} max-sm:text-primary text-[14.4px] whitespace-nowrap capitalize max-md:text-sm max-sm:text-xs`}
              >
                {getLocalizedTitle(link)}
              </NextLink>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
}

export default Navbar;
